import axios from 'axios';
import Cookies from 'js-cookie';

import { URLS } from '@/constants/urls';

export const fetch = axios.create({
  baseURL: URLS.API_URL,
  withCredentials: true,
  headers: {
    Authorization: Cookies.get('jwt') || '',
  },
});
